<template>
  <div
    v-if="request"
    class="viewRequest"
  >
    <vt-side-panel :visible="toggleSidepanel">
      <div class="px-3">
        <b-row class="mb-3">
          <b-col class="d-flex align-items-center">
            <span
              v-if="attachmentsSidepanel"
              class="title"
            >{{ $tc('global.file',2) }}</span>
          </b-col>
          <b-col
            cols="auto"
            class="d-flex justify-content-end"
          >
            <div>
              <b-button
                v-shortkey="['shift', 'esc']"
                class="btn__icon btn__icon--primary p-0"
                @shortkey="toggleSidepanel = false"
                @click="toggleSidepanel = false"
              >
                <i
                  class="far fa-times"
                  aria-hidden="true"
                />
              </b-button>
            </div>
          </b-col>
        </b-row>
        <div
          v-if="request.id"
          class="content-scroll"
        >
          <b-col
            v-if="attachmentsSidepanel && request.attachments.length"
            class="mt-2"
          >
            <!--TODO: operation to true until implemented-->
            <request-downloadable-attachment
              :attachments="request.attachments"
              :request-id="request.id"
              :lab-id="labId"
              :user-have-attach-operation="true"
              @deleteAttachment="onDeleteAttachment"
            />
          </b-col>
        </div>
      </div>
    </vt-side-panel>
    <!--Search header-->
    <b-row class="search-block mb-3 mt-1">
      <b-col
        xl="4"
        lg="6"
        md="6"
        sm="8"
      >
        <searcher-module-entity-selection
          case-search
          request-search
          subrequest-search
          show-entity-selector
          :identifier-options="entitySelectorOptionsForSearch"
          :initial-identifier="entitySelectorOptionsForSearch[0]"
          @studySearch="studySearch"
          @requestSearch="requestSearch"
          @subrequestSearch="subrequestSearch"
          @insuranceNumberSearch="onInsuranceNumberSearch"
        />
      </b-col>
      <b-col
        xl="8"
        lg="6"
        md="6"
        sm="4"
        class="text-right"
      >
        <div
          style="margin-top: 5px;"
          class="mx-2"
        >
          <b-button
            v-shortkey="['f10']"
            qa="registry-request-detail-patients-button"
            class="btn__link px-3"
            @shortkey.prevent="openPatientModal"
            @click="openPatientModal"
          >
            <i
              class="far fa-users mr-2"
              aria-hidden="true"
            />{{ $tc('global.patients') }}
          </b-button>
          <b-button
            id="requestsRouteToStudyRequestCreate"
            qa="registry-request-grid-create-request-button"
            class="ml-2 btn btn--primary btn-secondary btn-sm d-none"
          >
            <fa-icon
              class="mr-1"
              :icon="['fal', 'plus']"
            /> {{ $tc('global.request',1) }}
          </b-button>
        </div>
      </b-col>
    </b-row>

    <!--Patient Block-->
    <b-row class="mx-0 mb-3">
      <b-col class="pl-0 pr-0">
        <patient-card
          :patient="request.patient"
          @openPatientModal="showPatientModal"
        />
      </b-col>
    </b-row>
    <b-card class="float-component pt-3 mb-5">
      <b-row class="px-3">
        <b-col class="d-flex align-items-center">
          <div class="d-flex align-items-center">
            <span
              qa="registry-request-detail-request-label"
              class="ap-title ap-title__main mr-2"
            ><i
              class="far fa-file-medical mr-2"
              aria-hidden="true"
            />{{ request.label }}</span>
            <b-badge
              v-if="request.automaticallyCreated"
              v-tooltip="$t('global.automaticCreation')"
              pill
              class="ml-2 mr-1 icon-badge indicator-bubble d-flex align-items-center justify-content-center"
            >
              <i
                class="far fa-magic"
                aria-hidden="true"
              />
            </b-badge>
            <vtBubble
              v-show="incidentsCount"
              :number="incidentsCount"
              :type="true"
              :tooltip="' '+$t('grid.detail.hasAlarms')"
              class="ml-1"
              @click="openRequestIncidentTreeModal()"
            />
            <vtBubble
              v-show="request.attachments.length"
              class="mr-2"
              :number="request.attachments.length"
              :type="false"
              :tooltip="' '+$tc('global.file',2)"
              @click="showAttachments"
            />
            <study-request-priority-dot
              class="ml-2"
              :priority="request.priority"
              :size="10"
            />
            <study-request-status-badge
              class="ml-2"
              :status="request.status"
            />
          </div>
        </b-col>
        <b-col class="d-flex justify-content-end">
          <div class="switch-btn p-0 d-flex align-items-center mr-2">
            <span class="mr-2 printed-label-switch-title">{{ $t('global.scanCasePrintedLabel') }}</span>
            <input
              id="toggle-clinical-label"
              v-model="isExternalLabel"
              :value="isExternalLabel"
              type="checkbox"
              class="offscreen"
              aria-hidden="true"
              @change="saveSwitchExternalLabelState"
            >
            <label
              :qa="`registry-request-detail-printed-label-${isExternalLabel}`"
              for="toggle-clinical-label"
              class="switch mb-0"
            />
          </div>
          <b-button
            class="btn__icon btn__icon--primary px-2"
            @click="showInGlobalLocator(request.label)"
          >
            <i
              v-tooltip="$t('global.showInGlobalLocator')"
              aria-hidden="true"
              class="far fa-map-marker-alt"
            />
          </b-button>
        </b-col>
      </b-row>
      <!--Request Block-->
      <div class="my-2 mx-2 p-2 scroll-area">
        <b-row>
          <b-col class="form-box">
            <div class="structure">
              <div class="d-flex align-items-center">
                <span class="structure__heading mr-3">
                  <i
                    class="far fa-list mr-2"
                    aria-hidden="true"
                  />{{ $t('registry.cases.requestData') }}
                </span>
              </div>
              <b-row>
                <b-col
                  sm="6"
                  md="4"
                  lg="3"
                >
                  <div class="structure__data">
                    <small>{{ $tc('global.laboratory') }}</small>
                    <h4
                      qa="registry-request-detail-laboratory"
                      class="collapsable-card-title"
                    >
                      {{ request.laboratory ? request.laboratory.labName : '-' }}
                    </h4>
                  </div>
                </b-col>
                <b-col
                  sm="6"
                  md="4"
                  lg="3"
                >
                  <div class="structure__data">
                    <small>{{ $t('global.regime') }}</small>
                    <h4
                      qa="registry-request-detail-regime"
                      class="collapsable-card-title"
                    >
                      {{ request.regime ? request.regime.name : '-' }}
                    </h4>
                  </div>
                </b-col>
                <b-col
                  sm="6"
                  md="4"
                  lg="2"
                >
                  <div class="structure__data">
                    <small>{{ $t('global.episode') }}</small>
                    <h4
                      qa="registry-request-detail-episode"
                      class="collapsable-card-title"
                    >
                      {{ request.reqEpisode ? request.reqEpisode : '-' }}
                    </h4>
                  </div>
                </b-col>
                <b-col
                  sm="6"
                  md="4"
                  lg="2"
                >
                  <div class="structure__data">
                    <small>{{ $t('component.caseCardModal.studyId') }}</small>
                    <h4
                      qa="registry-request-detail-case-label"
                      class="collapsable-card-title"
                    >
                      {{ request.caseLabel ? request.caseLabel : '-' }}
                    </h4>
                  </div>
                </b-col>
                <b-col
                  sm="6"
                  md="4"
                  lg="2"
                >
                  <div class="structure__data">
                    <small>{{ $t('global.externalReference') }}</small>
                    <h4
                      qa="registry-request-detail-external-reference"
                      class="collapsable-card-title"
                    >
                      {{ request.externalReference ? request.externalReference : '-' }}
                    </h4>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  sm="12"
                  md="6"
                  lg="6"
                >
                  <div class="structure__data">
                    <small>{{ $t('global.relevantClinicalData') }}</small>
                    <h4
                      qa="registry-request-detail-clinical-data"
                      class="collapsable-card-title"
                    >
                      {{ request.clinicalData ? request.clinicalData.text : '-' }}
                    </h4>
                  </div>
                </b-col>
                <b-col
                  sm="12"
                  md="6"
                  lg="6"
                >
                  <div class="structure__data">
                    <small>{{ $t('global.observations') }}</small>
                    <h4
                      qa="registry-request-detail-observations"
                      class="collapsable-card-title"
                    >
                      {{ request.notes ? request.notes.text : '-' }}
                    </h4>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col
                  class="mb-3"
                  xl="6"
                  lg="12"
                >
                  <b-row>
                    <b-col
                      cols="auto"
                      class="d-flex align-items-center"
                    >
                      <span class="ap-title ap-title__divider">{{ $t('global.requester') }}</span>
                    </b-col>
                    <b-col>
                      <hr>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <div class="structure__data">
                        <small>{{ $t('component.studyRequest.form.clinicCard.physicianCenter') }}</small>
                        <h4
                          qa="registry-request-detail-physician-center"
                          class="collapsable-card-title inside"
                        >
                          {{ request.physicianDepartment ? request.physicianDepartment.center.name : '-' }}
                        </h4>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="structure__data">
                        <small>{{ $t('component.studyRequest.form.clinicCard.physicianDepartment') }}</small>
                        <h4
                          qa="registry-request-detail-physician-department"
                          class="collapsable-card-title inside"
                        >
                          {{ request.physicianDepartment ? request.physicianDepartment.name : '-' }}
                        </h4>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="structure__data">
                        <small>{{ $t('component.studyRequest.form.clinicCard.petitioner') }}</small>
                        <h4
                          qa="registry-request-detail-physician-petitioner"
                          class="collapsable-card-title inside"
                        >
                          {{ request.physicianPetitioner && request.physicianPetitioner.fullName ? request.physicianPetitioner.fullName : '-' }}
                        </h4>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <!-- TODO Front: Uncomment when development -->
                <!--<b-col class="mb-3" lg="12" xl="6">
                  <b-row>
                    <b-col
                      cols="auto"
                      class="d-flex align-items-center"
                    >
                      <span class="ap-title ap-title__divider">{{ $tc('global.insurance', 1) }}</span>
                    </b-col>
                    <b-col>
                      <hr>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <div class="structure__data">
                        <small>{{ $tc('global.insurance', 1) }}</small>
                        <h4
                          qa="registry-request-detail-physician-center"
                          class="collapsable-card-title inside"
                        >
                          -
                        </h4>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="structure__data">
                        <small>{{ $tc('global.insuranceDocument') }}</small>
                        <h4
                          qa="registry-request-detail-physician-department"
                          class="collapsable-card-title inside"
                        >
                            -
                        </h4>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="structure__data">
                        <small>{{ $tc('global.insurancePolicy') }}</small>
                        <h4
                          qa="registry-request-detail-physician-petitioner"
                          class="collapsable-card-title inside"
                        >
                            -
                        </h4>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>-->
                <b-col
                  lg="12"
                  xl="6"
                >
                  <b-row>
                    <b-col
                      cols="auto"
                      class="d-flex align-items-center"
                    >
                      <span class="ap-title ap-title__divider">{{ $t('registry.cases.destination') }}</span>
                    </b-col>
                    <b-col>
                      <hr>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <div class="structure__data">
                        <small>{{ $t('component.studyRequest.form.clinicCard.destinationCenter') }}</small>
                        <h4
                          qa="registry-request-detail-destination-center"
                          class="collapsable-card-title inside"
                        >
                          {{ request.destinationDepartment ? request.destinationDepartment.center.name : '-' }}
                        </h4>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="structure__data">
                        <small>{{ $t('component.studyRequest.form.clinicCard.destinationDepartment') }}</small>
                        <h4
                          qa="registry-request-detail-destination-department"
                          class="collapsable-card-title inside"
                        >
                          {{ request.destinationDepartment ? request.destinationDepartment.name : '-' }}
                        </h4>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="structure__data">
                        <small>{{ $t('global.sendTo') }}</small>
                        <h4
                          qa="registry-request-detail-destination-petitioner"
                          class="collapsable-card-title inside"
                        >
                          {{ request.reqAttn ? request.reqAttn : '-' }}
                        </h4>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="form-box">
            <div class="structure mb-0">
              <div class="d-flex align-items-center">
                <span class="structure__heading mr-3">
                  <i
                    class="far fa-prescription-bottle mr-2"
                    aria-hidden="true"
                  />{{ $tc('global.sample',2) }}
                </span>
              </div>
              <b-row>
                <b-col>
                  <vt-grid
                    class="view-request-grid"
                    qa="registry-request-detail-grid"
                    :column-defs="columnDefs"
                    :grid-options="gridOptions"
                    :row-data="subrequests"
                    :component-code="gridUiComponent"
                    @model-updated="onModelUpdated"
                  />
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
      <div slot="footer">
        <!--Button Section-->
        <div class="my-1 text-right">
          <vt-loading-button
            v-if="$_canPrintRequestReport()"
            v-shortkey="['alt', 'p']"
            class="btn__outline btn-sm ml-3"
            qa="registry-request-detail-print-request-button"
            :disabled="!$_canBeRequestReportPrinted(request)"
            :params="{ promise: printRequestReport }"
          >
            <i
              aria-hidden="true"
              class="fal fa-print mr-2"
            />{{ $t('registry.requestGrid.contextMenu.printRequest') }}
          </vt-loading-button>
          <b-button
            v-if="$_canCancelRequest()"
            v-shortkey="['alt', 'del']"
            class="btn__outline btn-sm ml-3"
            qa="registry-request-detail-cancel-request-button"
            :disabled="htmlDisabledRequestCancelButton"
            @shortkey.prevent="cancelRequest"
            @click="cancelRequest"
          >
            <i
              aria-hidden="true"
              class="far fa-times-circle mr-2"
            />{{ $t('registry.requestGrid.contextMenu.cancelRequest') }}
          </b-button>
          <b-button
            v-if="$_canCreateIncident()"
            class="btn__outline btn-sm ml-3"
            qa="registry-request-detail-register-incident-button"
            :disabled="!$_canBeIncidentCreatedToRequest(request)"
            @click="openIncidentFormModal"
          >
            <i
              aria-hidden="true"
              class="fal fa-file-alt mr-2"
            />{{ $t('hoverBtn.registerIncident') }}
          </b-button>
          <vt-loading-button
            v-if="$_canProcessRequest(request)"
            v-shortkey="['ctrl', 'enter']"
            class="btn--primary btn-sm ml-3"
            qa="registry-request-detail-process-request-button"
            :disabled="!canProcessRequestNow"
            :params="{ promise: processRequest }"
          >
            <i
              aria-hidden="true"
              class="far fa-check-circle mr-2"
            />{{ $t('registry.requestGrid.contextMenu.processRequest') }}
          </vt-loading-button>
          <b-button
            v-if="$_canGoToCaseView(request.status.code)"
            class="btn__outline ml-3"
            size="sm"
            qa="registry-request-detail-go-to-case-button"
            @click="editCase"
          >
            <i
              aria-hidden="true"
              class="fas fa-chart-network mr-2"
            />{{ $t('hoverBtn.goToCase') }}
          </b-button>
          <b-button
            v-if="visibleReturnAndPrintRequestButton"
            class="btn__outline ml-3"
            size="sm"
            qa="registry-request-detail-return-print-request-button"
            @click="returnRequest(true)"
          >
            <i
              aria-hidden="true"
              class="fas fa-print mr-2"
            />{{ $t('hoverBtn.returnPrint') }}
          </b-button>
          <b-button
            v-if="$_canReturnRequest(request.status.code)"
            class="btn__outline ml-3"
            size="sm"
            qa="registry-request-detail-return-request-button"
            @click="returnRequest(false)"
          >
            <i
              aria-hidden="true"
              class="fas fa-print mr-2"
            />{{ $t('hoverBtn.return') }}
          </b-button>
          <b-button
            v-if="$_canPrintReturnForm(request.status.code)"
            class="btn__outline ml-3"
            size="sm"
            qa="registry-request-detail-print-report-button"
            @click="printReturnForm()"
          >
            <i
              aria-hidden="true"
              class="fal fa-print mr-2"
            />{{ $t('hoverBtn.printReport') }}
          </b-button>
        </div>
      </div>
    </b-card>

    <modal-patient-card
      id="modalPatientCard"
      ref="modalPatientCard"
      :patient-id="request.patient.patId"
    />
    <modal-confirmation-checkable
      id="viewRequestConfirmationModalCheckable"
      ref="confirmationModalCheckable"
      :name="nameModal"
      :store-name="storeNameModal"
      :content="messageModal"
      :ui-component="uiComponentModal"
    />
    <common-incident-modal-tree
      ref="incidentModalTree"
      :is-request="true"
      @incident-added="onIncidentAdded()"
    />
    <incident-form-modal
      id="incidentFormModal"
      ref="incidentFormModal"
      :core-entity="coreEntity"
      @incident-added="onIncidentAdded()"
    />
    <modal-confirmation
      id="confirmationModalViewRequest"
      ref="confirmationModal"
      :content="$t('registry.viewRequest.loadNewRequest')"
    />
    <print-component ref="printComponent" />
    <scan-printed-label-modal
      ref="printedLabelModal"
      @externalLabel="onProcessConfirmation($event)"
    />
    <modal-wrapper ref="searchPatientModal">
      <search-patient-modal id-modal="searchPatientModal" />
    </modal-wrapper>
    <modal-wrapper ref="patientSelectionModalWrapper">
      <patient-selection-modal
        id="patientSelectionModal"
        @continue="processModal"
      />
    </modal-wrapper>
  </div>
</template>

<script>
import { StoreUtils } from '@/shared/util/store-utils'
import ModalConfirmation from '@/components/modals/ModalConfirmation'
import VtGrid from '@/components/VtGrid/VtGrid'
import StudyRequestPriorityDot from '@/modules/clinicalModule/components/StatusRequestPriorityDot'
import columnsViewRequestGrid from './config/RegistrySubrequestGridColumns'
import ModalPatientCard from '@/components/modals/ModalPatientCard'
import StudyRequestStatusBadge from '@/modules/clinicalModule/components/StudyRequestStatusBadge'
import VtBubble from '@/components/common/VtBubble'
import registryRequestResource from '@/modules/RegistryModule/services/registryRequestResource'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import ModalConfirmationCheckable from '@/components/modals/ModalConfirmationCheckable'
import IncidentFormModal from '@/components/incidentsModal/IncidentFormModal'
import CommonIncidentModalTree from '@/components/incidentsModal/CommonIncidentModalTree'
import RequestDownloadableAttachment from '@/modules/clinicalModule/components/RequestDownloadableAttachment'
import Encoder from '@/utils/encoder'
import incidentServices, { COREENTITY_VALUES } from '@/api/resources/incident/incidentServices'
import ScanPrintedLabelModal from '@/modules/RegistryModule/views/viewRequest/ScanPrintedLabelModal'
import CustomConfigResource from '@/api/resources/ui/CustomConfigResource'
import { REQUEST_STATES } from '@/api/resources/entityState/request-state'
import { IDENTIFIER_SCOPES, INSURANCE_NUMBER } from '@/api/resources/identifierScopesResource'
import SearcherModuleEntitySelection from '@/components/SearcherModuleEntitySelection'
import patientDiscrepancyServices from '@/api/resources/patientDiscrepancyServices'
import PatientSelectionModal from '@/modules/RegistryModule/components/patientDiscrepancyModal/PatientSelectionModal'
import { RequestOperationGuardMixin } from '@/api/operations/mixins/guards/request-operation-guard.mixin'
import { IncidentOperationGuardMixin } from '@/api/operations/mixins/guards/incident-operation-guard.mixin'
import SearchPatientModal from '@/components/searcherPatientModal/SearchPatientModal'
import PatientCard from '@/modules/clinicalModule/components/PatientCard'
import { GridUtils } from '@/shared/util/grid-utils'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

export default {
    name: 'RegistryRequestDetail',
    components: {
        PatientCard,
        SearcherModuleEntitySelection,
        ModalConfirmationCheckable,
        VtGrid,
        StudyRequestPriorityDot,
        ModalPatientCard,
        StudyRequestStatusBadge,
        VtBubble,
        IncidentFormModal,
        CommonIncidentModalTree,
        ModalConfirmation,
        RequestDownloadableAttachment,
        ScanPrintedLabelModal,
        PatientSelectionModal,
        SearchPatientModal
    },
    mixins: [
        RequestOperationGuardMixin,
        IncidentOperationGuardMixin
    ],
    data() {
        return {
            gridUiComponent: 'uicomponent.registry.subrequestgrid',
            REQUEST_STATES: REQUEST_STATES,
            isExternalLabel: false,
            toggleSidepanel: false,
            attachmentsSidepanel: false,
            attachments: [],
            incidents: [],
            subrequestSelected: false,
            selectedRows: [],
            encoder: new Encoder(),
            columnDefs: columnsViewRequestGrid(),
            request: null,
            gridApi: null,
            subrequests: [],
            storeNameModal: 'registryModalsState',
            uiComponentModal: 'uicomponent.registry.modalconfig',
            uicomponentExternalLabel: 'uicomponent.registry.caseFormExternalLabel',
            messageModal: '',
            nameModal: null,
            coreEntity: 'REQUEST',
            incidentsCount: 0
        }
    },
    computed: {
        visibleReturnAndPrintRequestButton() {
            return this.$_canReturnRequestAndPrintReturnForm(this.request.status.code) && this.canIncidentRequestReportBePrinted
        },
        canIncidentRequestReportBePrinted() {
            return this.request.metadata.operationGuards.canIncidentReportBePrinted
        },
        routePath() {
            return this.$route.path
        },
        htmlDisabledRequestCancelButton() {
            return !this.request || !this.request.metadata.operationGuards.canBeCancelled
        },
        entitySelectorOptionsForSearch() {
            return [{ scopes: [IDENTIFIER_SCOPES.REQUEST, IDENTIFIER_SCOPES.SUBREQUEST], icon: 'fal fa-file-medical', text: this.$tc('registry.searcher.requestOrSamples'), errorMessage: this.$t('registry.errors.validIdentifierRequest') },
                { scopes: [IDENTIFIER_SCOPES.CASE], icon: 'fal fa-chart-network', text: this.$tc('global.case', 1), errorMessage: this.$t('registry.errors.validIdentifierCase') },
                { id: INSURANCE_NUMBER, icon: 'far fa-file-alt', text: this.$tc('global.insurancePolicy') }]
        },
        hasCanisterTracking() {
            const activeModule =
                StoreUtils.selectedLaboratoryConfiguration?.activeModules.find(
                    module => module.moduleCode === 'configuration.parameter.laboratory.module.registry.canisterTracking.active')
            return !!activeModule?.activeStatus
        },
        allSubrequestsSelected() {
            return this.selectedRows.length === this.subrequests.length
        },
        canProcessRequestNow() {
            let canProcess = false
            if (this.hasCanisterTracking) {
                canProcess = this.allSubrequestsSelected
            } else {
                canProcess = true
            }
            return canProcess
        },
        showModalProcessConfirmation() {
            return !this.hasCanisterTracking && !this.allSubrequestsSelected
        },
        gridOptions() {
            return {
                onGridReady: this.onGridReady,
                paginationPageSize: 20,
                paginationAutoPageSize: false,
                rowHeight: 25,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                onSelectionChanged: this.onSelectionChanged,
                sideBar: gridSideBarConfig,
                onSortChanged: () => {
                    if (this.gridApi) this.gridApi.deselectAll()
                },
                onFilterChanged: () => {
                    if (this.gridApi) this.gridApi.deselectAll()
                },
                autoGroupColumnDef: {
                    headerName: 'Consoles', // custom header name for group
                    pinned: 'left', // force pinned left. Does not work in columnDef
                    cellRendererParams: {
                        suppressCount: true // remove number in Group Column
                    }
                }
            }
        },
        patientTimeOld() {
            return this.request.patient && this.getPatientTimeOld(this.request.patient.patBirthdate)
        },
        labId() {
            return this.$store.getters.labId
        }
    },
    watch: {
        async routePath() {
            await this.loadRequest()
            this.selectedRows = []
        }
    },
    async mounted() {
        await this.loadRequest()
        const isExternalRequestLabelCustomConfig = await CustomConfigResource.get(this.uicomponentExternalLabel)
        if (isExternalRequestLabelCustomConfig && isExternalRequestLabelCustomConfig.config) {
            this.isExternalLabel = isExternalRequestLabelCustomConfig.config.isExternalLabel
        }
    },
    methods: {
        onModelUpdated(api) {
            if (this.$route.params.subrequest) {
                this.selectGridSubrequestByLabel(api, this.$route.params.subrequest)
            }
        },
        showInGlobalLocator(label) {
            this.$eventHub.$emit('show-in-global-locator', label)
        },
        async getRequestIncidents() {
            this.updateLoading(true)
            const [err, response] = await this.toCall(incidentServices.getRequestIncidents(this.labId, this.request.id))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.incidents = response
            this.incidentsCount = response.length
        },
        saveSwitchExternalLabelState() {
            const isExternalRequestLabel = { isExternalLabel: this.isExternalLabel }
            CustomConfigResource.save(this.uicomponentExternalLabel, isExternalRequestLabel)
        },
        onIncidentAdded() {
            this.loadRequest()
            this.getRequestIncidents()
            this.$emit('updateSummary')
        },
        async loadRequest() {
            if (this.$route.params.id) {
                const [err, response] = await this.toCall(registryRequestResource.getRequest(this.labId, this.$route.params.id))
                if (err) {
                    this.showErrorModalGlobal()
                }
                this.request = response.data
                this.incidentsCount = response.data.incidents
                this.subrequests = response.data.subrequests
            }
        },
        selectGridSubrequestByLabel(api, label) {
            api.forEachNode((node) => {
                if (node.data.label === label) {
                    node.setSelected(true)
                }
            })
        },
        onDeleteAttachment() {
            this.toggleSidepanel = false
            this.showSuccessModalGlobal(this.$t('clinical.form.attachemntDeletedSuccessfully'))
            this.loadRequest()
        },
        async showAttachments() {
            this.toggleSidepanel = !this.toggleSidepanel
            if (this.toggleSidepanel) {
                this.attachmentsSidepanel = true
            }
        },
        editCase() {
            this.$router.push({ name: 'registryEditCase', params: { id: this.request.caseId } })
        },
        onSelectionChanged({ api }) {
            this.subrequestSelected = api.getSelectedRows().length === 1
            this.selectedRows = api.getSelectedRows()
        },
        async requestSearch(searchInformation) {
            if (this.request.label === searchInformation.trim()) {
                this.$_showWarningModal(this.$tc('registry.requestGrid.search.alreadyLoaded'))
                return
            }
            const params = {
                requestLabel: searchInformation
            }
            const response =
                await this.$_toCallUnique(
                    registryRequestResource.searchByRequestLabel(this.labId, params))
            if (response?.length) {
                let entitySelected = response[0]
                if (response?.length > 1) {
                    const foundEntities =
                        response.map(entity => ({
                            entityType: IDENTIFIER_SCOPES.REQUEST,
                            entityValue: {
                                ...entity,
                                requestDate: entity.reqRequestDate
                            },
                            laboratoryId: entity.laboratory.labId
                        }))
                    entitySelected = await this.$_showMultiEntitySelection(searchInformation, foundEntities)
                }
                const isRequestInAnotherLaboratory = entitySelected.laboratory.labId !== this.$store.getters.labId
                if (isRequestInAnotherLaboratory) {
                    this.$refs.requestTransferModal.show(entitySelected)
                } else {
                    this.$refs.confirmationModal.ask(() =>
                        this.$router.push({ name: 'viewRequest', params: { id: entitySelected.id } }))
                }
            } else {
                this.$_showErrorModal(this.$tc('registry.requestGrid.search.noRequest'))
            }
        },
        async studySearch(searchInformation) {
            const filter = {
                'caseStudy.casCasenumber': GridUtils.getTextFilterModel('equals', searchInformation)
            }
            const filterModel = this.encoder.encode(this.encoder.parseBooleans(filter))
            const response =
                await this.$_toCallUnique(
                    registryRequestResource.paginator(filterModel, undefined, this.labId))
            if (response) {
                if (response.content.length) {
                    if (this.request.id === response.content[0].id) {
                        this.$_showWarningModal(this.$tc('registry.requestGrid.search.alreadyLoaded'))
                    } else {
                        this.$refs.confirmationModal.ask(() => {
                            this.$router.push({ name: 'viewRequest', params: { id: response.content[0].id } })
                        })
                    }
                } else {
                    this.$_showErrorModal(this.$tc('registry.requestGrid.search.noRequest'))
                }
            }
        },
        async subrequestSearch(searchInformation) {
            let subrequestSelected = false
            this.selectGridSubrequestByLabel(this.gridApi, searchInformation.trim())
            if (subrequestSelected) return

            const params = {
                subrequestLabel: searchInformation
            }

            const response =
                await this.$_toCallUnique(
                    registryRequestResource.searchBySubrequestLabel(this.labId, params))
            if (response?.length) {
                let entitySelected = response[0]
                if (response.length > 1) {
                    const foundEntities =
                        response.map(entity => ({
                            entityType: IDENTIFIER_SCOPES.REQUEST,
                            entityValue: entity,
                            laboratoryId: entity.laboratory.labId
                        }))
                    entitySelected = await this.$_showMultiEntitySelection(searchInformation, foundEntities)
                }
                const isRequestInAnotherLaboratory = entitySelected.laboratory.labId !== this.$store.getters.labId
                if (isRequestInAnotherLaboratory) {
                    this.$refs.requestTransferModal.show(entitySelected, searchInformation)
                } else {
                    this.$refs.confirmationModal.ask(() =>
                        this.$router.push({
                            name: 'viewRequest',
                            params: {
                                id: entitySelected.id,
                                subrequest: searchInformation
                            }
                        }))
                }
            } else {
                this.$_showErrorModal(this.$tc('registry.requestGrid.search.noRequest'))
            }
        },
        async onInsuranceNumberSearch(searchInformation) {
            const filter = {
                'insuranceNumber': {
                    filterType: 'text',
                    type: 'contains',
                    filter: searchInformation
                }
            }
            const encodedFilterModel = this.encoder.encode(this.encoder.parseBooleans(filter))
            const response = await this.$_toCallUnique(registryRequestResource.paginator(encodedFilterModel, undefined, this.labId))
            if (response?.content?.length) {
                let entitySelected = response.content[0]
                if (response.content.length > 1) {
                    this.$router.push({ name: 'requestGrid', params: { filterModel: filter } })
                } else {
                    const isRequestInAnotherLaboratory = entitySelected.laboratory.labId !== this.$store.getters.labId
                    if (isRequestInAnotherLaboratory) {
                        this.$refs.requestTransferModal.show(entitySelected)
                    } else {
                        if (this.request.id !== entitySelected.id) {
                            this.$refs.confirmationModal.ask(() =>
                                this.$router.push({ name: 'viewRequest', params: { id: entitySelected.id } }))
                        } else {
                            this.$_showWarningModal(this.$tc('registry.requestGrid.search.alreadyLoaded'))
                        }
                    }
                }
            } else {
                this.$_showErrorModal(this.$tc('registry.requestGrid.search.noRequest'))
            }
        },

        openIncidentFormModal() {
            this.$refs.incidentFormModal.show(null, { requestId: this.request.id })
        },
        openRequestIncidentTreeModal() {
            const entityInfo = {
                coreEntity: COREENTITY_VALUES.REQUEST.code,
                requestId: this.request.id
            }
            this.$refs.incidentModalTree.show(entityInfo, this.request.patient.patId)
        },
        openPatientModal() {
            this.$refs.searchPatientModal.show()
        },
        async getLocalPatientWithDiscrepancies() {
            const [error, response] = await this.toCall(patientDiscrepancyServices.getPendingToResolveLocalPatientDiscrepancies(this.labId, this.request.id))
            if (error) {
                if (error.response.status !== 404) {
                    this.showErrorModalGlobalFromErrorResponse(error)
                }
                return false
            }
            return response
        },
        processModal() {
            this.nameModal = 'modalProcessConfirmation'
            if (!this.getModalConfirmationState(this.nameModal) && this.showModalProcessConfirmation) {
                this.messageModal = this.$t('component.modalProcess.title') + ` ${
                    this.request.label
                }?`
                this.$refs.confirmationModalCheckable.show(() => {
                    if (this.isExternalLabel) {
                        this.$refs.printedLabelModal.show()
                    } else {
                        this.onProcessConfirmation()
                    }
                })
            } else {
                if (this.isExternalLabel) {
                    this.$refs.printedLabelModal.show()
                } else {
                    this.onProcessConfirmation()
                }
            }
        },
        async getIntegrationPatient() {
            this.updateLoading(true)
            const [error, response] = await this.toCall(patientDiscrepancyServices.getPatientWithDiscrepancy(this.labId, this.request.id))
            this.updateLoading(false)
            if (error) {
                this.showErrorModalGlobalFromErrorResponse(error)
                return
            }
            return response
        },
        async processRequest() {
            if (this.request.hasPendingDiscrepancies) {
                const integrationPatient = await this.getIntegrationPatient()
                const localPatientWithDiscrepancies = await this.getLocalPatientWithDiscrepancies()
                this.$refs.patientSelectionModalWrapper.show([localPatientWithDiscrepancies, integrationPatient, this.request.patient.patId, this.request.id, this.request.label, this.labId])
            } else {
                this.processModal()
            }
        },
        cancelRequest() {
            this.nameModal = 'modalCancelConfirmation'
            if (!this.getModalConfirmationState(this.nameModal)) {
                this.messageModal = this.$t('component.modalCancel.title') + ` ${
                    this.request.label
                }?`
                this.$refs.confirmationModalCheckable.show(() => {
                    this.onCancelConfirmation()
                })
            } else {
                this.onCancelConfirmation()
            }
        },
        returnRequest(shouldPrintReturnForm) {
            this.nameModal = 'modalReturnConfirmation'
            if (!this.getModalConfirmationState(this.nameModal)) {
                this.messageModal = this.$t('component.modalReturn.title') + ` ${
                    this.request.label
                }?`
                this.$refs.confirmationModalCheckable.show(() => {
                    this.onReturnConfirmation(shouldPrintReturnForm)
                })
            } else {
                this.onReturnConfirmation(shouldPrintReturnForm)
            }
        },
        async printReturnForm() {
            this.updateLoading(true)
            const [err, report] = await this.toCall(incidentServices.getFirstRequestIncidentReport(this.labId, this.request.id))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobalFromErrorResponse(err)
                return
            }
            const filePDF = new Blob([report], { type: 'application/pdf' })
            const fileURL = window.URL.createObjectURL(filePDF)
            window.open(fileURL)
        },
        async onProcessConfirmation(caseLabel = null) {
            this.updateLoading(true)
            let [error, response] = await this.toCall(registryRequestResource.processRequest(
                this.labId,
                this.request.id,
                caseLabel
            ))
            if (error) {
                this.updateLoading(false)
                this.$_showErrorModalFromErrorResponse(error, this.$t('registry.index.saveFormError'))
                return
            }
            this.$refs.printedLabelModal.hide()
            this.$router.push({ name: 'registryEditCase', params: { id: response.data.casId, caseData: response.data } })
        },
        async onCancelConfirmation() {
            this.updateLoading(true)
            let [error] = await this.toCall(registryRequestResource.cancelRequest(
                this.labId,
                this.request.id
            ))
            if (error) {
                this.updateLoading(false)
                this.showErrorModalGlobal()
                return
            }
            await this.loadRequest()
            this.showSuccessModalGlobal(this.$t('studyRequest.info.requestCanceled'))
            this.updateLoading(false)
        },
        async onReturnConfirmation(printReturnForm) {
            this.updateLoading(true)
            let params = {
                'entityIdentifiers': [this.request.id]
            }
            let [error] = await this.toCall(registryRequestResource.returnRequest(params))
            if (error) {
                this.updateLoading(false)
                this.showErrorModalGlobal()
                return
            }
            await this.loadRequest()
            this.showSuccessModalGlobal(this.$t('registry.requestGrid.successReturn'))
            this.updateLoading(false)
            if (printReturnForm) {
                await this.printReturnForm()
            }
        },
        getModalConfirmationState(modalName) {
            return this.$_getModalConfirmationState(this.storeNameModal, modalName)
        },
        onGridReady({ api }) {
            this.gridApi = api
            if (this.$route.params.subrequest) {
                this.gridApi.forEachNode((node) => {
                    if (node.data.label === this.$route.params.subrequest) {
                        node.setSelected(true)
                    }
                })
            }
        },
        showPatientModal() {
            this.$refs['modalPatientCard'].show()
        },

        /**
             * PRINT METHODS
             */
        async printRequestReport() {
            // TODO Check unsaved changes
            await this.$refs.printComponent.printRequestReportFromRegistry(this.request)
            // TODO Add request reload
        }
    }
}
</script>

<style lang="scss">

    .viewRequest .float-component {
        flex-grow: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        .card-body {
            flex-grow: 1;
            min-height: 0;
            display: flex;
            flex-direction: column;
            .scroll-area {
                flex-grow: 1;
                overflow-y: auto;
                overflow-x: hidden;
            }
        }
    }

    .viewRequest .printed-label-switch-title {
        font-size: font-size(small);
    }

    .viewRequest .switch {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 20px;
        background-color: rgba(0, 0, 0, 0.25);
        border-radius: 20px;
        transition: all 0.3s;
        cursor: pointer;
    }

    .viewRequest .switch::after {
        content: "";
        position: absolute;
        width: 18px;
        height: 18px;
        border-radius: 18px;
        background-color: white;
        top: 1px;
        left: 1px;
        transition: all 0.3s;
    }

    .viewRequest input[type="checkbox"]:checked + .switch::after {
        transform: translateX(20px);
    }

    .viewRequest input[type="checkbox"]:checked + .switch {
        background-color: vt-color(primary);
    }

    .viewRequest .offscreen {
        position: absolute;
        left: -9999px;
    }

    .viewRequest .card-body{
        padding: 0;
    }

    .viewRequest .flex-btn{
        width: 5% !important;
    }

    .viewRequest .custom-width{
        width: 33.3% !important;
    }

    .viewRequest .ag-root-wrapper-body.ag-layout-normal{
        padding: 0;
    }

</style>

<style scoped>

    .view-request-grid {
        height: 100%;
        min-height: 220px;
    }

</style>
